"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.opravnenNaZadostCheck = exports.getJmenoNazevAutora = exports.getJmenoPrijmeni = exports.vyhledejUkoly = exports.getNameValue = void 0;
var __1 = require("../..");
var either_1 = require("../../utils/either");
var getNameValue = function (jmeno, prijmeni, titul, titulZa) {
    var name = [titul, prijmeni, jmeno].filter(function (e) { return e; }).join(' ');
    if (titulZa) {
        return name + ", " + titulZa;
    }
    return name;
};
exports.getNameValue = getNameValue;
var vyhledejUkoly = function (idSubjektu, postZasobnikPrace, jeZnalec, notifikace) { return __awaiter(void 0, void 0, void 0, function () {
    var query, response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                query = {
                    filter: {
                        subjekt: {
                            idSubjekt: idSubjektu,
                            jeZnalec: jeZnalec,
                        },
                        idStavu: 1,
                        zobrazitUzivateli: true,
                        kategorieUdalosti: notifikace ? [__1.KategorieUdalosti.Notifikace] : [__1.KategorieUdalosti.Kontrola],
                    },
                };
                return [4 /*yield*/, postZasobnikPrace(query)];
            case 1:
                response = _b.sent();
                if (either_1.isRight(response)) {
                    return [2 /*return*/, ((_a = response.value) === null || _a === void 0 ? void 0 : _a.zaznamy) || []];
                }
                return [2 /*return*/, []];
        }
    });
}); };
exports.vyhledejUkoly = vyhledejUkoly;
var getJmenoPrijmeni = function (jmeno, prijmeni, titul, titulZa) {
    var name = [titul, jmeno, prijmeni].filter(function (e) { return e; }).join(' ');
    if (titulZa) {
        return name + ", " + titulZa;
    }
    return name;
};
exports.getJmenoPrijmeni = getJmenoPrijmeni;
var getJmenoNazevAutora = function (autor) {
    var role = (autor === null || autor === void 0 ? void 0 : autor.role) && autor.role !== null ? "(" + autor.role + ")" : '';
    return ((autor === null || autor === void 0 ? void 0 : autor.jmeno) && (autor === null || autor === void 0 ? void 0 : autor.prijmeni) ? (autor === null || autor === void 0 ? void 0 : autor.jmeno) + " " + (autor === null || autor === void 0 ? void 0 : autor.prijmeni) : autor === null || autor === void 0 ? void 0 : autor.nazev) + " " + role;
};
exports.getJmenoNazevAutora = getJmenoNazevAutora;
var opravnenNaZadostCheck = function (opravneni, typ) {
    return opravneni.includes(__1.TypyZadostiSeznam.kompletniZapis) || opravneni.includes(typ);
};
exports.opravnenNaZadostCheck = opravnenNaZadostCheck;
